import React from 'react';

import { Block } from '../common/Block.jsx';
import { default as Image, ImageBlockV2 } from '../common/Image.jsx';
import Url from '../common/Url.jsx';

// region HOME LINK V1 (-- DEPRECATED Use `HomeLinkV2` --)

function HomeLinkV1Component(props) {
    const config = props.config || {};
    const link = Url.getHomeLink(props.baseUrl, props.querySub, props.queryLayout, props.queryDataSub, props.builder);

    const classNamePrefix = props.footer ? 'foot' : 'nav';
    let className = `${classNamePrefix}__logo ${classNamePrefix}__logo--${props.type || 'desktop'}`;
    let linkStyle = {};
    if (props.builder) {
        className += ' builder';
        linkStyle.pointerEvents = 'none';
    } else if (props.disabled) {
        linkStyle.pointerEvents = 'none';
    }
    let imageStyle;
    if (props.blockConfig && props.blockConfig.layout) {
        imageStyle = {};
        Block.mapStyleConfigProps(imageStyle, props.blockConfig.layout, (propName, propValue) => {
            switch (propName) {
                case 'textAlign':
                    linkStyle[propName] = propValue;
                    return true;
            }
        });
    }
    let content;
    if (config.logo) {
        const imageUrl = Image.url(config.logo)
        if (config.logo.extension && config.logo.extension.toLowerCase() == 'svg') {
            if (!imageStyle) {
                imageStyle = {};
            }
            imageStyle.height = '100%';
            imageStyle.width = '100%';
        }
        content = (
            <a className={className} href={link} style={linkStyle}>
                <img alt={config.company} src={imageUrl} style={imageStyle} />
            </a>
        );
    } else {
        let display = config.company;
        if (props.builder && (!display || display.length == 0)) {
            display = '[No Logo Set]';
        }
        linkStyle.display = 'inline-block';
        linkStyle.width = '100%';
        content = <a className={`${classNamePrefix}__menu__anch ${className}`} href={link} style={linkStyle}>{display}</a>;
    }
    if (props.wrapperClassName) {
        content = <div className={props.wrapperClassName}>{content}</div>;
    }
    if (props.type == 'mobile') {
        return (
            <React.Fragment>
                {content}
                <div className="mobile__spacer" />
            </React.Fragment>
        )
    }
    return content;
}
const HomeLinkV1 = { Component: HomeLinkV1Component };

// region HOME LINK V2

function HomeLinkV2Component(props) {
    const config = props.config || {};
    const imageUrl = Image.url(config.logo);
    const link = Url.getHomeLink(props.baseUrl, props.querySub, props.queryLayout, props.queryDataSub, props.builder);

    let style;
    if (props.disabled) {
        style = { pointerEvents: 'none' };
    }
    const classNamePrefix = props.footer ? 'foot' : 'nav';
    let className = `${classNamePrefix}__logo ${classNamePrefix}__logo--${props.type || 'desktop'}`;
    let imageContent, imageStyle;
    if (!imageUrl) {
        className = `${classNamePrefix}__menu__anch ${className}`;

        let display = config.company;
        if (props.builder && (!display || display.length == 0)) {
            display = '[No Logo Set]';
        }
        imageContent = <span style={{ fontSize: '16px' }}>{display}</span>
    } else if (config.logo.extension && config.logo.extension.toLowerCase() == 'svg') {
        imageStyle = { height: '100%', width: '100%' };
    }
    return (
        <ImageBlockV2.Component
            {...props}
            className={className}
            imageContent={imageContent}
            imageStyle={imageStyle}
            imageUrl={imageUrl}
            link={link}
            style={style} />
    );
}
const HomeLinkV2 = { Component: HomeLinkV2Component };

export {
    HomeLinkV2,

    // DEPRECATED
    HomeLinkV1
};